import { saveAs } from 'file-saver';

export default class ExcelDownload {
    // payload = {
    //     name: 'carros'
    //     header: ['cor', 'ano', 'marca', 'modelo'],
    //     body: [
    //         ['azul', '2017', 'honda', 'civic'],
    //         ['laranja', '2005', 'ford', 'fiesta'],
    //         ['preto', '2022', 'fiat', 'fastback'],
    //     ]
    // }
    // excel:
    // cor    | ano   | marca   | modelo
    // azul   | 2017  | honda   | civic
    // laranja| 2005  | ford    | fiesta
    // preto  | 2022  | fiat    | fastback

    constructor(payload) {
        const XLSX = require('sheetjs-style');
        var wb = XLSX.utils.book_new();
        const formattedGroupName = payload.groupName ? `Grupo: ${payload.groupName}` : 'Grupo não especificado';

        wb.Props = {
            Title: payload.tableName || "SheetJS",
            Subject: "Valores",
            Author: payload.author ? payload.author : "Club da Cotação",
            CreatedDate: new Date(),
            Company: formattedGroupName,
        };

        wb.SheetNames.push(payload.tableName.trim());
        const now = new Date();
        var ws_data = [];

        ws_data.push([
            payload.author ? payload.author : "Club da Cotação",
            // payload.store,
            payload.userName,
            now.toLocaleDateString(),
            formattedGroupName,
            payload.cot || ""
        ]);

        ws_data.push(payload.header);
        ws_data.push(...payload.body);

        var ws = XLSX.utils.aoa_to_sheet(ws_data);

        if (payload.colWidths) {
            ws["!cols"] = payload.colWidths.map(width => ({ wch: width }));
        } else {
            ws["!cols"] = [{ wch: 15 }, { wch: 20 }, { wch: 10 }, { wch: 15 },
            { wch: 15 }, { wch: 20 }, { wch: 15 }];
        }

        const centerAlignment = {
            alignment: {
                horizontal: "center",
                vertical: "center"
            }
        };

        const titleStyle = {
            font: {
                bold: true,
                color: { rgb: "000000" }
            },
            ...centerAlignment
        };

        const headerStyle = {
            font: {
                bold: true,
                color: { rgb: "FFFFFF" }
            },
            fill: {
                fgColor: { rgb: payload.headerColor ? payload.headerColor.replace('#', '') : "FF7110" }
            },
            ...centerAlignment
        };

        const bodyStyle = {
            ...centerAlignment
        };

        ws["A1"].s = titleStyle;
        ws["B1"].s = titleStyle;
        ws["C1"].s = titleStyle;
        ws["D1"].s = titleStyle;
        if (ws["E1"]) ws["E1"].s = titleStyle;
        if (ws["F1"]) ws["F1"].s = titleStyle;

        const headerRow = 1;
        Object.keys(ws).forEach(cell => {
            const col = XLSX.utils.decode_cell(cell);
            if (col.r === headerRow) {
                ws[cell].s = headerStyle;
            } else if (col.r > headerRow) {
                ws[cell].s = bodyStyle;
            }
        });

        ws["!margin"] = { left: 0.5, right: 0.5, top: 0.5, bottom: 0.5 };

        wb.Sheets[payload.tableName.trim()] = ws;

        var wbout = XLSX.write(wb, {
            bookType: 'xlsx',
            type: 'binary',
            Props: wb.Props
        });

        function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }

        saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
            payload.tableName.trim() + '.xlsx');
    }
}

